import { NgModule } from '@angular/core';
import {AsyncPipe, NgIf} from '@angular/common';
import { GonvarriOrderDetailItemsComponent } from '../../components/gonvarri-order-detail-items/gonvarri-order-detail-items.component';
import {
  OutletModule,
  PromotionsModule,
} from "@spartacus/storefront";
import {AuthGuard, I18nModule, provideConfig} from "@spartacus/core";
import {AbstractOrderContextModule} from "@spartacus/cart/base/components";
import {GonvarriCartSharedModule} from "../gonvarri-cart-shared-module/gonvarri-cart-shared-module.module";
import {
  GonvarriOrderConsignedEntriesModule
} from "../gonvarri-order-consigned-entries/gonvarri-order-consigned-entries.module";
import {GonvarriAddToCartModule} from "../gonvarri-add-to-cart/gonvarri-add-to-cart.module";
import {OrderDetailsModule, OrderDetailsService, ReplenishmentOrderDetailsService} from "@spartacus/order/components";
import {ApproverGuard, OrderApprovalDetailService} from "@spartacus/organization/order-approval";
import {UnitLevelOrdersViewerGuard} from "@spartacus/organization/unit-order/core";
import {UnitLevelOrderDetailService} from "@spartacus/organization/unit-order/components";

@NgModule({
  declarations: [
    GonvarriOrderDetailItemsComponent
  ],
  imports: [
    GonvarriCartSharedModule,
    GonvarriOrderConsignedEntriesModule,
    AsyncPipe,
    I18nModule,
    PromotionsModule,
    OutletModule,
    AbstractOrderContextModule,
    GonvarriAddToCartModule,
    NgIf,
    OrderDetailsModule
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        AccountOrderDetailsItemsComponent: {
          component: GonvarriOrderDetailItemsComponent,
          guards: [AuthGuard]
        },
        AccountOrderDetailsGroupedItemsComponent: {
          component: GonvarriOrderDetailItemsComponent,
          guards: [AuthGuard],
        },
        ReplenishmentDetailItemsComponent: {
          component: GonvarriOrderDetailItemsComponent,
          providers: [
            {
              provide: OrderDetailsService,
              useExisting: ReplenishmentOrderDetailsService,
            },
          ],
        },
        OrderApprovalDetailItemsComponent: {
          component: GonvarriOrderDetailItemsComponent,
          providers: [
            {
              provide: OrderDetailsService,
              useExisting: OrderApprovalDetailService,
            },
          ],
          guards: [AuthGuard, ApproverGuard],
        },
        UnitLevelOrderDetailsItemsComponent: {
          component: GonvarriOrderDetailItemsComponent,
          guards: [AuthGuard, UnitLevelOrdersViewerGuard],
          providers: [
            {
              provide: OrderDetailsService,
              useExisting: UnitLevelOrderDetailService,
            },
          ],
        },
      }
    })
  ]
})
export class GonvarriOrderDetailItemsModule { }
